<template>
  <div class="depotfinder-result">
    <header class="depotfinder-result__header">
      <span class="depotfinder-result__subline">{{ subline }}</span>
      <UiHeadline tag="h1" size="large" theme="accent" class="mb-0">
        {{ depositModel.name }}
      </UiHeadline>
    </header>

    <div class="depositmodel-benefits">
      <div class="flex-grid grid-pad">
        <div class="flex-grid__col c-12">
          <h3 class="depositmodel-benefits__headline">
            {{ $t("depotfinder.results.benefits") }}
          </h3>
          <ul class="benefits-list">
            <li
              v-for="(benefit, index) in depositBenefits"
              v-html="benefit"
              :key="index"
            ></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="depotfinder-result__footer flex-grid grid-pad">
      <div class="flex-grid__col c-7">
        <div class="depositmodel-conditions">
          <h3 class="depositmodel-conditions__headline">
            <span>{{ $t("depotfinder.results.condition") }}</span>
            <a
              class="icon-btn help-btn icon-btn--primary"
              target="_blank"
              rel="noopener norefferer"
              v-bind:href="depositModel.more_information_link"
              v-if="depositModel.more_information_link"
            >
              <svg width="24" height="24">
                <use xlink:href="#icon-info" />
              </svg>
            </a>
          </h3>
          <div class="depositmodel-conditions__content">
            <ul class="list list--conditions">
              <li
                v-for="(item, index) in depositModelConditions(
                  depositModel.conditions
                )"
                v-html="item"
                :key="index"
              ></li>
            </ul>
            <button
              v-if="currentActiveDepositModel.indexOf('DepotExklusiv') != -1"
              class="btn btn--small btn--outline btn--secondary mt-1"
              @click="openChangeTarrifView"
            >
              {{ $t("depotfinder.results.change_tariff") }}
            </button>
          </div>
        </div>
      </div>
      <div class="flex-grid__col c-5 flex flex-v-end flex-h-end">
        <UiButton theme="primary" @click.native="openInformationView()">
          {{ $t("depotfinder.results.request_information") }}
        </UiButton>
      </div>
    </div>

    <div v-if="showCtaBox" class="depotfinder-result__extra">
      <div class="cta-box">
        <h3 class="cta-box__headline">
          <svg width="20" height="19">
            <use xlink:href="#icon-star" />
          </svg>
          {{ $t(`depotfinder.results.${ctaBoxText}.headline`) }}
        </h3>
        <p v-html="$t(`depotfinder.results.${ctaBoxText}.text`)"></p>
      </div>
    </div>
  </div>
</template>

<script>
import UiHeadline from "./../components/Ui/Headline.vue";
import UiButton from "./Ui/Button/index.vue";
import { depositModelConditions } from "./../mixins/depositModelConditions.js";

export default {
  components: {
    UiHeadline,
    UiButton,
  },
  mixins: [depositModelConditions],
  props: {
    depositModel: {
      type: Object,
      required: true,
    },
    recommendedDeposit: {
      type: String,
      required: true,
    },
    activeDepositModel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showCtaBox: false,
      ctaBoxText: "",
    };
  },
  computed: {
    subline() {
      let currentActiveModel = this.$store.getters.getActiveDeposit;
      return currentActiveModel == this.recommendedDeposit
        ? this.$t("depotfinder.results.subline")
        : this.$t("depotfinder.results.subline_alt");
    },
    currentActiveDepositModel() {
      return this.$store.getters.getActiveDeposit;
    },
    depositBenefits() {
      if (
        this.activeDepositModel == "MeinVermögen" ||
        this.activeDepositModel == "Vermögensverwaltung"
      ) {
        return this.depositModel.benefits;
      } else {
        return this.getDepositBenefits(this.depositModel);
      }
    },
  },
  methods: {
    getDepositBenefits(model) {
      let benefits = this.$t("depositBenefits");
      let depositBenefits = [];

      // Handle special case for DepotFuture with an extra benefit
      if (model.shortname == "DepotFuture") {
        depositBenefits.push(model.special_benefit);
      }

      Object.keys(benefits).forEach(function(key) {
        if (model.benefits && model.benefits[key]) {
          depositBenefits.push(benefits[key]);
        }
      });
      return depositBenefits;
    },
    openChangeTarrifView() {
      this.$store.dispatch("updateView", {
        view: "changeTarrifView",
        payload: true,
      });
      this.$store.dispatch("updateView", {
        view: "overlayBG",
        payload: true,
      });
    },
    openInformationView() {
      this.$store.dispatch("updateView", {
        view: "informationView",
        payload: true,
      });
    },
  },
  mounted() {
    // Show MeinVermögen, if chosen option in step "Assets" was < 250k
    // Otherwise show Vermögensverwaltung if >= 250k
    // But only show if user selected option "bank" in step 1
    if (
      this.$store.getters.getAssetsState != "" &&
      this.$store.getters.getDecisionState.indexOf("bank") != -1
    ) {
      // < 250k
      if (
        this.$store.getters.getAssetsState < 7 &&
        this.recommendedDeposit != "MeinVermögen"
      ) {
        this.showCtaBox = true;
        // Set ctaBoxText based on selection
        this.ctaBoxText = "mein-vermoegen";

        // Also preselect "MeinVermögen" for informationView
        this.$store.dispatch("updateInformationState", {
          index: "selectedSpecialModels",
          payload: ["MeinVermögen"],
        });

        // >= 250k
      } else if (
        this.$store.getters.getAssetsState >= 7 &&
        this.recommendedDeposit != "Vermögensverwaltung"
      ) {
        this.showCtaBox = true;

        // Set ctaBoxText based on selection
        this.ctaBoxText = "vermoegensverwaltung";

        // Also preselect "Vermögensverwaltung" for informationView
        this.$store.dispatch("updateInformationState", {
          index: "selectedSpecialModels",
          payload: ["Vermögensverwaltung"],
        });
      }
    } else {
      // reset selectedSpecialModels
      if (this.$store.getters.getDecisionState.indexOf("bank") == -1) {
        this.$store.dispatch("updateInformationState", {
          index: "selectedSpecialModels",
          payload: [],
        });
      }
    }

    // Remove "MeinVermögen" from selectedSpecialModels if recommended Deposit is "Vermögensverwaltung"
    if (
      this.recommendedDeposit == "Vermögensverwaltung" &&
      this.$store.getters.getSelectedSpecialModelsInformationState.indexOf(
        "MeinVermögen"
      ) != -1
    ) {
      this.$store.dispatch("updateInformationState", {
        index: "selectedSpecialModels",
        payload: [],
      });
    }
  },
};
</script>
